export default __webpack_public_path__ + "static/media/02.1c041091.jpg";